import script from "./WizardCurtainDeviceRegistStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardCurtainDeviceRegistStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardCurtainDeviceRegistStep.vue?vue&type=style&index=0&id=1178a76e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1178a76e"]])

export default __exports__